export class AnswerIndexedDbRepo {
  constructor(db) {
    this.db = db;
  }

  save({ value, formId, path, status, questionId, questionType }) {
    const item = {
      id: `${formId}.${path}`,
      formId,
      value,
      status,
      path,
      questionId,
      questionType,
    };
    return this.db.answers.put(item);
  }

  getAnswers({ formId, status }) {
    return this.db.answers.where({ formId, status }).toArray();
  }

  async deleteList(answerIds) {
    await this.db.answers.bulkDelete(answerIds);
  }

  async setAnswersStatus(answerIds, status) {
    await Promise.all(answerIds.map((id) => this.setAnswerStatus(id, status)));
  }

  async setAnswerStatus(id, status) {
    await this.db.answers.update(id, { status });
  }

  async count(formId) {
    return (await this.db.answers.where({ formId }).keys()).length;
  }

  allFormIds() {
    return this.db.answers.orderBy('formId').uniqueKeys();
  }

  async getFormAnswerIds(formId) {
    return this.db.answers.where({ formId }).primaryKeys();
  }

  async deleteFormAnswers(formId) {
    await this.deleteList(await this.getFormAnswerIds(formId));
  }
}
